<template src="./material.html"></template>

<script>
  import { store } from '../../store/store'
  import SettingSidebar from '../common/settingsidebar/settingsidebar'
  import Select from '../common/select/select.vue'
  import ImportCsvModal from './modal/ImportCsv.vue'
  import auth from '../../helpers/auth'
  import axios from 'axios'
  import { toTitleCase } from '../../helpers/titleCase'
  import { resolveItemImageUrl } from '../../helpers/itemImageUrl'

  export default {
    name: 'material',
    components: {
      'app-setting-sidebar': SettingSidebar,
      'app-select': Select,
      'app-import-csv-modal': ImportCsvModal
    },
    data: function () {
      return {
        materials: [],
        material: {
          name: '',
          description: '',
          cost: '',
          sell_price: '',
          unit: '',
          category_id: null,
          is_active: true
        },
        modalVisible: false,
        importCsvVisible: false,
        loading: false,
        searchText: '',
        searchResults: [],
        filterType: '',
        activeTab: 'default', // 'default' or 'custom'
        paginator: {
          page: 1,
          totalPages: 0,
          nextPage: 0,
          previousPage: 0,
          total: 0
        },
        materialTypes: []
      }
    },
    methods: {
      displayCatalogName: function (value) {
        return toTitleCase(value)
      },
      getMaterials: function (page = 1) {
        this.loading = true;
        const params = {
          page: page,
          limit: 50,
          type: this.activeTab
        };
        
        if (this.searchText) params.search = this.searchText;
        if (this.filterType) params.type_id = this.filterType;
        
        console.log('📦 Fetching materials with params:', params);
        
        axios.get('/api/materials', { params })
          .then(response => {
            console.log('📦 Materials received:', (response.data.materials && response.data.materials.length) || 0, 'items');
            this.materials = response.data.materials || [];
            const apiPagination = response.data.pagination || { page: 1, total: 0, pages: 0, limit: params.limit };
            const currentPage = apiPagination.page || 1;
            const totalPages = apiPagination.totalPages || apiPagination.pages || Math.ceil((apiPagination.total || 0) / (apiPagination.limit || params.limit || 50)) || 0;
            this.paginator = {
              page: currentPage,
              totalPages,
              previousPage: currentPage > 1 ? currentPage - 1 : 0,
              nextPage: currentPage < totalPages ? currentPage + 1 : 0,
              total: apiPagination.total || 0,
              limit: apiPagination.limit || params.limit || 50
            };
            console.log('📦 Materials array length:', this.materials.length);
            if (this.materials.length > 0) {
              console.log('📦 First material:', this.materials[0]);
            }
          })
          .catch(error => {
            console.error('❌ Error fetching materials:', error);
            console.error('📄 Error response:', error.response);
            this.materials = [];
          })
          .finally(() => {
            this.loading = false;
          });
      },
      
      newMaterial: function () {
        this.$router.push('/settings/product/new');
      },
      
      viewMaterial: function (material, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (!material || !material.id) return;
        this.$router.push('/settings/product/' + material.id);
      },
      
      search: function () {
        if (this.searchText.length >= 2 || this.searchText.length === 0) {
          this.paginator.page = 1;
          this.getMaterials(1);
        }
      },
      
      filterByType: function (typeId) {
        this.filterType = typeId;
        this.paginator.page = 1;
        this.getMaterials(1);
      },
      
      clearFilters: function () {
        this.searchText = '';
        this.filterType = '';
        this.paginator.page = 1;
        this.getMaterials(1);
      },
      
      changeTab: function (tab) {
        // Admin users can only access the default tab
        if (this.$store.getters['user/isPlatformAdmin'] && tab === 'custom') {
          return;
        }
        
        this.activeTab = tab;
        this.paginator.page = 1;
        this.getMaterials(1);
      },
      
      getMaterialTypes: function () {
        // Use the material types from the store instead of API
        this.materialTypes = this.$store.getters['material/getTypes'];
      },
      

      
      getImageUrl: function (material) {
        const placeholder = require('../../assets/img/no-image-available.jpg')
        return resolveItemImageUrl(material, this.$store.getters['getImageUrl'], placeholder)
      },
    },
    
    watch: {
      searchText() {
        this.search();
      },
      
      // Ensure admin users stay on default tab
      activeTab(newTab) {
        if (this.$store.getters['user/isPlatformAdmin'] && newTab === 'custom') {
          this.activeTab = 'default';
          this.getMaterials(1);
        }
      }
    },
    
    created: function () {
      console.log('🔧 Material component created');
      /**
       * Component requires authentication, check if user is authenticated
       */
      auth.check(this);

      this.getMaterials();
      this.getMaterialTypes();
    },
    mounted: function () {
      console.log('🔧 Material component mounted');
      console.log('🔧 viewMaterial method exists:', typeof this.viewMaterial === 'function');
      console.log('🔧 User store state:', {
        isAuthenticated: this.$store.getters['user/isAuthenticated'],
        isPlatformAdmin: this.$store.getters['user/isPlatformAdmin'],
        isManager: this.$store.getters['user/isManager'],
        canCreateContent: this.$store.getters['user/canCreateContent'],
        profile: this.$store.getters['user/getProfile']
      });
      console.log('🔧 Materials array length:', this.materials.length);
      
      // Wait for DOM to render, then check rows and bind click handlers
      this.$nextTick(() => {
        const rows = this.$el.querySelectorAll('.material-row');
        console.log('🔧 Found', rows.length, 'material rows in DOM');
        if (rows.length > 0) {
          console.log('🔧 First row:', rows[0]);
          console.log('🔧 First row classes:', rows[0].className);
          
          // Add direct event listener as backup to ensure clicks work
          rows.forEach((row, index) => {
            const material = this.materials[index];
            if (material) {
              // Remove any existing listeners first
              const newRow = row.cloneNode(true);
              row.parentNode.replaceChild(newRow, row);
              
              // Add click handler directly to the row
              newRow.addEventListener('click', (e) => {
                console.log('🔧 Direct event listener fired on material row!', material);
                e.preventDefault();
                e.stopPropagation();
                // Call Vue method directly as fallback
                this.viewMaterial(material, e);
              }, false);
              
              // Also add to each cell for redundancy
              const cells = newRow.querySelectorAll('td');
              cells.forEach(cell => {
                cell.addEventListener('click', (e) => {
                  console.log('🔧 Cell click fired!', material);
                  e.preventDefault();
                  e.stopPropagation();
                  this.viewMaterial(material, e);
                }, false);
              });
            }
          });
        } else {
          console.warn('⚠️ No material rows found in DOM - materials may not be loaded yet');
          // Retry after materials load
          setTimeout(() => {
            const retryRows = this.$el.querySelectorAll('.material-row');
            console.log('🔧 Retry: Found', retryRows.length, 'material rows after delay');
          }, 1000);
        }
      });
    }
  }
</script>

<style scoped>
.ui.table th {
  background: transparent !important;
}

.material-row {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.material-row.clickable:hover {
  background-color: var(--color-very-light-grey) !important;
}

.material-row {
  cursor: pointer !important;
}

.pagination-controls {
  margin-top: 20px;
  text-align: center;
}

/* Tab styling */
.ui.tabular.menu .item {
  cursor: pointer;
}

.ui.tabular.menu .item.active {
  border: none;
  margin-bottom: 0;
  color: var(--color-primary);
  background: transparent;
  box-shadow: none;
}

/* Table styling */
.ui.table th {
  background-color: #f9fafb;
  font-weight: 600;
}

.ui.table td {
  vertical-align: middle;
}

/* Image placeholder styling */
.image.icon {
  display: block;
  margin: 0 auto;
}

/* Empty state styling */
.empty-state-container {
  background: var(--color-bg-document-card);
  border: 1px solid var(--color-border-document-card);
  border-radius: 4px;
  padding: 40px 20px;
  text-align: center;
  margin: 20px 0;
}

.empty-state-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-state-title {
  font-family: var(--font-semibold);
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 8px 0;
}

.empty-state-description {
  font-family: var(--font-semibold);
  font-size: 14px;
  color: var(--color-text-muted);
  margin: 0;
  line-height: 1.4;
}
</style>

